export interface QuizQuestion {
  id: string;
  text: string;
  options: [string, string] | [string, string, string, string];
  correct: 0 | 1 | 2 | 3;
  phase: 1 | 2 | 3 | 4;
  points: number;
  type: 'true-false' | 'multiple-choice';
}

// ── 15 câu Đúng/Sai (phase 1 & 2) ──
const TRUE_FALSE_QUESTIONS: QuizQuestion[] = [
  {
    id: 'tf1', phase: 1, points: 10, type: 'true-false',
    text: 'Nước sông có màu đen đục và bốc mùi hôi là biểu hiện của ô nhiễm nước.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
  {
    id: 'tf2', phase: 1, points: 10, type: 'true-false',
    text: 'Khói từ việc đốt rác nhựa làm không khí có mùi khét là biểu hiện ô nhiễm không khí.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
  {
    id: 'tf3', phase: 1, points: 10, type: 'true-false',
    text: 'Bãi đất có nhiều mảnh chai vỡ và túi nilon là biểu hiện của môi trường sạch đẹp.',
    options: ['Đúng', 'Sai'],
    correct: 1,
  },
  {
    id: 'tf4', phase: 1, points: 10, type: 'true-false',
    text: 'Tiếng còi xe và tiếng máy khoan kêu quá to liên tục là biểu hiện ô nhiễm tiếng ồn.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
  {
    id: 'tf5', phase: 1, points: 10, type: 'true-false',
    text: 'Nước sông trong vắt, không có rác thải là biểu hiện của môi trường nước sạch.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
  {
    id: 'tf6', phase: 1, points: 10, type: 'true-false',
    text: 'Mùi thơm của hoa rừng và không khí mát mẻ là dấu hiệu của ô nhiễm không khí.',
    options: ['Đúng', 'Sai'],
    correct: 1,
  },
  {
    id: 'tf7', phase: 2, points: 10, type: 'true-false',
    text: 'Xác cá chết nổi nhiều trên mặt nước là biểu hiện nguồn nước bị ô nhiễm.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
  {
    id: 'tf8', phase: 2, points: 10, type: 'true-false',
    text: 'Đất ven sông bị thấm dầu mỡ đen sì là biểu hiện của ô nhiễm đất.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
  {
    id: 'tf9', phase: 2, points: 10, type: 'true-false',
    text: 'Tiếng chim hót và tiếng suối chảy róc rách là biểu hiện của ô nhiễm tiếng ồn.',
    options: ['Đúng', 'Sai'],
    correct: 1,
  },
  {
    id: 'tf10', phase: 2, points: 10, type: 'true-false',
    text: 'Bụi đường bay mù mịt làm em bị ho và đau mắt là biểu hiện ô nhiễm không khí.',
    options: ['Đúng', 'Sai'],
    correct: 0,
  },
];

// ── 15 câu Trắc nghiệm (phase 2, 3 & 4) ──
const MULTIPLE_CHOICE_QUESTIONS: QuizQuestion[] = [
  {
    id: 'mc1', phase: 2, points: 15, type: 'multiple-choice',
    text: 'Biểu hiện nào sau đây cho thấy môi trường nước đang bị ô nhiễm?',
    options: ['Nước sông có màu xanh tự nhiên.', 'Nước sông có mùi hôi và nhiều rác.', 'Nước sông trong, nhìn thấy đáy.', 'Nước sông mát lạnh vào buổi sáng.'],
    correct: 1,
  },
  {
    id: 'mc2', phase: 2, points: 15, type: 'multiple-choice',
    text: 'Dấu hiệu nào giúp em nhận biết môi trường không khí bị ô nhiễm?',
    options: ['Bầu trời trong xanh, nắng ấm áp.', 'Gió thổi mát mẻ và có hương hoa.', 'Có khói đen và mùi khét nồng nặc.', 'Không khí thoáng đãng, dễ hít thở.'],
    correct: 2,
  },
  {
    id: 'mc3', phase: 2, points: 15, type: 'multiple-choice',
    text: 'Đâu là biểu hiện của ô nhiễm đất tại bến sông?',
    options: ['Đất bằng phẳng, có nhiều cỏ xanh.', 'Đất sạch sẽ, không có rác thải nhựa.', 'Đất chứa nhiều túi nilon và mảnh vỡ.', 'Đất ẩm ướt sau khi thủy triều xuống.'],
    correct: 2,
  },
  {
    id: 'mc4', phase: 2, points: 15, type: 'multiple-choice',
    text: 'Âm thanh nào được coi là biểu hiện của ô nhiễm tiếng ồn?',
    options: ['Tiếng học sinh thảo luận bài nhóm trong lớp học.', 'Tiếng bước chân của các bạn đi lại trên hành lang.', 'Tiếng lá cây xào xạc khi có cơn gió nhẹ thổi qua.', 'Tiếng máy khoan đục bê tông kêu quá to liên tục.'],
    correct: 3,
  },
  {
    id: 'mc5', phase: 3, points: 20, type: 'multiple-choice',
    text: 'Khi thấy nước sông có váng dầu loang lổ, đó là dấu hiệu của?',
    options: ['Nguồn nước sạch, đảm bảo vệ sinh cho sinh hoạt.', 'Nguồn nước bị nhiễm bẩn bởi xăng dầu từ tàu thuyền.', 'Nguồn nước có nhiều bùn đất cuộn lên sau cơn mưa.', 'Nguồn nước chảy xiết từ khu vực rừng núi về bến.'],
    correct: 1,
  },
  {
    id: 'mc6', phase: 3, points: 20, type: 'multiple-choice',
    text: 'Ô nhiễm không khí thường gây ra biểu hiện gì cho cơ thể?',
    options: ['Làm mắt sáng và nhìn rõ mọi vật hơn.', 'Làm cơ thể cảm thấy khỏe mạnh, sảng khoái.', 'Làm tăng khả năng tập trung khi học bài.', 'Làm mắt bị cay, đỏ và gây ho kéo dài.'],
    correct: 3,
  },
  {
    id: 'mc7', phase: 3, points: 20, type: 'multiple-choice',
    text: 'Thấy cá chết nổi nhiều trên sông là biểu hiện của môi trường nào?',
    options: ['Môi trường nước đang bị ô nhiễm.', 'Môi trường nước đang rất sạch đẹp.', 'Môi trường nước có quá nhiều cá tôm.', 'Môi trường nước đang được bảo vệ.'],
    correct: 0,
  },
  {
    id: 'mc8', phase: 3, points: 20, type: 'multiple-choice',
    text: 'Dấu hiệu của một dòng sông sạch, không bị ô nhiễm là?',
    options: ['Nước đen đục, có nhiều ruồi muỗi.', 'Mặt sông có nhiều bọt trắng hóa chất.', 'Ven bờ sông có nhiều bãi rác tự phát.', 'Nước trong veo, không có rác thải.'],
    correct: 3,
  },
  {
    id: 'mc9', phase: 3, points: 20, type: 'multiple-choice',
    text: 'Tại sao vứt pin cũ ra đất là biểu hiện phá hoại môi trường đất?',
    options: ['Vì pin cũ làm đất bị nhiễm độc nặng.', 'Vì pin cũ cung cấp phân bón cho đất.', 'Vì pin cũ giúp đất có nhiều màu sắc.', 'Vì pin cũ sẽ tự biến mất sau vài ngày.'],
    correct: 0,
  },
  {
    id: 'mc10', phase: 3, points: 20, type: 'multiple-choice',
    text: 'Khi bụi đường bay mù mịt làm hạn chế tầm nhìn, đó là biểu hiện của?',
    options: ['Môi trường không khí sạch và trong lành.', 'Thời tiết thuận lợi để tham gia thể thao.', 'Hiện tượng tự nhiên thường gặp buổi sáng.', 'Ô nhiễm không khí do khói và bụi bẩn.'],
    correct: 3,
  },
  {
    id: 'mc11', phase: 4, points: 25, type: 'multiple-choice',
    text: 'Biểu hiện nào cho thấy bến sông đang bị ô nhiễm cảnh quan?',
    options: ['Cây cối ven bờ xanh mát và sạch sẽ.', 'Có nhiều rác thải nhựa vứt bừa bãi.', 'Người dân cùng nhau dọn vệ sinh.', 'Có biển báo nhắc nhở bỏ rác đúng nơi.'],
    correct: 1,
  },
  {
    id: 'mc12', phase: 4, points: 25, type: 'multiple-choice',
    text: 'Tiếng ồn từ máy móc kêu quá to sát khu dân cư gây ra biểu hiện gì?',
    options: ['Gây cảm giác mệt mỏi và đau đầu.', 'Tạo ra sự yên bình cho làng quê.', 'Giúp mọi người làm việc hiệu quả hơn.', 'Tạo ra âm thanh vui tươi, náo nhiệt.'],
    correct: 0,
  },
  {
    id: 'mc13', phase: 4, points: 25, type: 'multiple-choice',
    text: 'Dòng nước từ cống thải có màu lạ và bọt trắng dâng cao là biểu hiện của?',
    options: ['Nước sông đang được lọc sạch tự nhiên.', 'Ô nhiễm nước do hóa chất thải trực tiếp.', 'Nước sông có nhiều sinh vật đang sống.', 'Hiện tượng dòng sông chuyển mùa bình thường.'],
    correct: 1,
  },
  {
    id: 'mc14', phase: 4, points: 25, type: 'multiple-choice',
    text: 'Rác thải nhựa trôi nổi trên sông gây ra biểu hiện xấu nào sau đây?',
    options: ['Giúp dòng sông trở nên rực rỡ màu sắc.', 'Giúp các loài sinh vật dưới nước phát triển.', 'Làm mất cảnh quan và ô nhiễm nguồn nước.', 'Giúp thuyền di chuyển nhanh hơn trên sông.'],
    correct: 2,
  },
  {
    id: 'mc15', phase: 4, points: 25, type: 'multiple-choice',
    text: 'Học sinh bỏ rác đúng nơi quy định là để tránh biểu hiện nào?',
    options: ['Tránh làm môi trường bị ô nhiễm, bẩn thỉu.', 'Tránh làm cho cây xanh phát triển nhanh.', 'Tránh việc không khí trở nên trong lành hơn.', 'Tránh việc cá tôm sinh sôi dưới dòng sông.'],
    correct: 0,
  },
];

export const QUESTIONS: QuizQuestion[] = [...TRUE_FALSE_QUESTIONS, ...MULTIPLE_CHOICE_QUESTIONS];

// Hàm lấy câu hỏi ngẫu nhiên theo phase, ưu tiên đúng/sai ở phase 1-2, trắc nghiệm ở phase 3-4
export function getRandomQuestion(phase: GamePhase, usedIds: Set<string>): QuizQuestion {
  // Lấy pool theo phase, ưu tiên câu chưa dùng
  let pool = QUESTIONS.filter(q => q.phase === phase && !usedIds.has(q.id));
  // Nếu hết câu chưa dùng, lấy tất cả câu của phase đó
  if (pool.length === 0) {
    pool = QUESTIONS.filter(q => q.phase === phase);
  }
  // Nếu vẫn không có, lấy tất cả câu
  if (pool.length === 0) {
    pool = QUESTIONS;
  }
  return pool[Math.floor(Math.random() * pool.length)];
}

export type GamePhase = 1 | 2 | 3 | 4;

export interface PhaseConfig {
  obstacleSpeed: number;
  obstacleMove: boolean;
  obstacleCount: number;
  boatBaseSpeed: number;
  spawnInterval: number;
}

export const PHASE_CONFIG: Record<GamePhase, PhaseConfig> = {
  1: { obstacleSpeed: 1.2, obstacleMove: false, obstacleCount: 2, boatBaseSpeed: 2,   spawnInterval: 180 },
  2: { obstacleSpeed: 1.8, obstacleMove: true,  obstacleCount: 3, boatBaseSpeed: 2.5, spawnInterval: 150 },
  3: { obstacleSpeed: 2.5, obstacleMove: true,  obstacleCount: 4, boatBaseSpeed: 3,   spawnInterval: 120 },
  4: { obstacleSpeed: 3.2, obstacleMove: true,  obstacleCount: 5, boatBaseSpeed: 3.5, spawnInterval: 90  },
};

export const OBSTACLE_TYPES = ['rock', 'branch', 'log', 'whirlpool', 'fog', 'dirt', 'oilspill'] as const;
export type ObstacleType = typeof OBSTACLE_TYPES[number];

export const TRASH_TYPES = ['bag', 'bottle', 'can'] as const;
export type TrashType = typeof TRASH_TYPES[number];

export const GAME_DURATION = 300;
export const MAX_LIVES = 5;
export const ERRORS_PER_LIFE = 3;
export const BOOST_DURATION = 120;
export const SLOW_DURATION = 90;
export const QUIZ_DURATION = 30;
export const DODGE_POINTS = 3;
